module.exports = __webpack_public_path__ + "img/SET.e66e5214.png";